<script setup>
import {defineProps, defineEmits, ref} from 'vue';

// The component has a prop, "open"
const props = defineProps({
    open: Boolean
});

// The component can emit two events, "confirm" and "cancel"
const emit = defineEmits(['confirm', 'cancel']);

// Add a ref for the loading state
const loading = ref(false);

const cancel = () => {
    emit('cancel');
};

const confirm = async () => {
    // When confirm starts, set loading to true
    loading.value = true;

    try {
        await emit('confirm');  // assuming the parent component handles the confirm event with a Promise
    } catch (err) {
        console.error(err);
    } finally {
        // When confirm is finished, set loading back to false
        loading.value = false;
    }
};
</script>

<template>
    <div v-if="props.open"
         class="fixed top-0 left-0 w-full h-full flex items-center justify-center bg-black bg-opacity-50 z-50">
        <div class="bg-white rounded-lg p-8">
            <slot></slot>
            <div class="flex justify-center ltr:space-x-2 rtl:space-x-reverse-2 mt-4">
                <button :disabled="loading" @click="confirm"
                        class="px-4 py-2 rounded bg-green-500 text-white ltr:order-first rtl:order-last rtl:mr-2">
                    <span v-if="!loading">{{ $tt('confirmation_modal__yes_button') }}</span>
                    <svg v-else class="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg"
                         fill="none" viewBox="0 0 24 24">
                        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor"
                                stroke-width="4"></circle>
                        <path class="opacity-75" fill="currentColor"
                              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg>
                </button>
                <button :disabled="loading" @click="cancel" class="px-4 py-2 rounded bg-red-500 text-white">{{ $tt('confirmation_modal__no_button') }}
                </button>
            </div>
        </div>
    </div>
</template>